<script>
	import { navigate } from "svelte-routing";

	export let empleados, userCard, indexPersona;
	$: console.log(empleados)
	const dirigirCard = (id) =>{
		userCard = empleados[id.index];
		indexPersona = userCard.id;
		navigate(`/card/${userCard.id}`, {replace: false});
	}
</script>

<div>
	<h2>
		Lista de Vcards
	</h2>
	<ul>
		{#each empleados as empleado, index}
		<li on:click={()=>dirigirCard({index})}>
			{empleado.nombres}
		</li>
		{/each}
	</ul>
</div>

<style lang="scss">
div{
	text-align: center;
	color: var(--blue-dark);
	text-decoration: none;
	h2{
		font-size: 25px;
	}
	ul{
		text-align: left;
		li{
			padding: 5px;
		}
	}
}
</style>